<template>
    <div id="highTask">
        <!-- 导航栏 -->
        <div id="headers">
            <img src="../../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText" v-if="switchNum == 0">评论任务</div>
            <div class="headerText" v-else>提交审核</div>
            <div class="rule" v-if="switchNum != 0" @click="inHighTaskExamineByLaws">细则</div>
        </div>
        <!-- 导航切换栏 -->
        <!-- <div class="switchColumn">
            <div class="cols" v-for="(items,indexs) in switchColumn" :key="indexs" :style="{color:(switchNum == indexs ? '#151515' : '#666666')}" @click="switchChoose(indexs)">
                {{items}}
                <span class="switchLine" v-if="switchNum == indexs"></span>
                <span class="switchLineNone" v-else></span>
            </div>
        </div> -->

        <!-- 投放中 -->
        <div class='switchOne' v-if="switchNum == 0">
            <!-- 当前任务 -->
            <div class="currentTasks currentMargin">
                <div class="title">
                    <div class="linesR"></div>
                    <div class="fonts">当前任务</div>
                    <div class="linesR"></div>
                </div>
                <div class="taskItem" v-for="(item,index) in currentTasks" :key="index" @click="inHighTaskOngoing(item)">
                    <div class="taskItemLeft">
                        <img :src="item.icon" alt="">
                        <div class="centers">
                            <div class="taskTile">{{item.name}}</div>
                            <div class="others">
                                <span>剩{{item.current_amount - item.active_num}}份</span>
                            </div>
                        </div>
                    </div>
                    <div class="taskItemRight">
                        <div v-if="item.status == 1" class="onging">待审核</div>
                        <div v-if="item.status != 1 && item.current !== 1" class="tuserNum">+{{item.tuser_price}}<span>元</span></div>
                        <div v-if="item.status != 1 && item.current == 1" class="onging">进行中</div>
                    </div>
                </div>
                <div class="nothingTask" v-if="currentTasks.length <= 0">
                    {{currentTaskToast}}
                </div>
            </div>
            <!-- 任务预告 -->
            <!-- <div class="taskForecast forecastMargin">
                <div class="title">
                    <div class="linesR"></div>
                    <div class="fonts">任务预告</div>
                    <div class="linesR"></div>
                </div>
                <div class="taskItem" v-for="(ite,ind) in taskForecast" :key="ind">
                    <div class="taskItemLeft">
                        <div class="imgsDay imgsDayOne" v-if="ite.start_time.day == '今日'">
                            <span>{{ite.start_time.day}}</span>
                            <span>{{ite.start_time.time}}</span>
                        </div>
                        <div class="imgsDay imgsDayTwo" v-else-if="ite.start_time.day == '明日'">
                            <span>{{ite.start_time.day}}</span>
                            <span>{{ite.start_time.time}}</span>
                        </div>
                        <div class="imgsDay imgsDayThree" v-else-if="ite.start_time.day == '后日'">
                            <span>{{ite.start_time.day}}</span>
                            <span>{{ite.start_time.time}}</span>
                        </div>
                        <div class="centers">
                            <div class="taskTile">{{ite.name}}</div>
                            <div class="others">
                                <span class="pay" v-if="ite.ischarge == 1">付费</span>
                                <span v-else-if="ite.ischarge == 0">免费</span>
                                <span>剩{{ite.remaining_number}}份</span>
                            </div>
                        </div>
                    </div>
                    <div class="taskItemRight">
                        <div class="tuserNum">+{{ite.tuser_price}}<span>元</span></div>
                    </div>
                </div>

                <div class="nothingTask" v-if="taskForecast.length <= 0">
                    {{taskForecastToast}}
                </div>
            </div> -->
            <!-- 没有更多了 -->
            <div class="tips">没有更多了</div>
        </div>

        <!-- 审核中 -->
        <!-- <div class="switchTwo" v-else-if="switchNum == 1">
            <div class="examine examineMargin">
                <div class="taskItem" v-for="(datas,keys) in examine" :key="keys" :class="keys == 0?'firstPadding':''" @click="inAuditStatus(datas.task_id)">
                    <div class="taskItemLeft">
                        <img :src="datas.icon" alt="">
                        <div class="centers">
                            <div class="taskTile">{{datas.name}}</div>
                            <div class="others">
                                <span class="pay" v-if="datas.ischarge == 1">付费</span>
                                <span v-else-if="datas.ischarge == 0">免费</span>
                                <span>剩{{datas.remaining_number}}份</span>
                            </div>
                        </div>
                    </div>
                    <div class="taskItemRight">
                        <div class="tuserNum">+{{datas.tuser_price}}<span>元</span></div>
                    </div>
                </div>

                <div class="nothingTask" v-if="examine.length <= 0">
                    {{examineToast}}
                </div>
            </div>

            
        </div> -->

        <!-- 已完成 -->
        <!-- <div class="switchThree" v-else-if="switchNum == 2">
            <div class="accomplishTasks accomplishMargin">
                <div class="taskItem" v-for="(ites,inds) in accomplish" :key="inds"  :class="inds == 0?'firstPadding':''" @click="lookState(ites.status)">
                    <div class="taskItemLeft">
                        <img :src="ites.icon" alt="">
                        <div class="centers">
                            <div class="taskTile">{{ites.name}}</div>
                            <div class="others">
                                <span class="pay" v-if="ites.ischarge == 1">付费</span>
                                <span v-else-if="ites.ischarge == 0">免费</span>
                                <span>剩{{ites.remaining_number}}份</span>
                            </div>
                        </div>
                    </div>
                    <div class="taskItemRight">
                        <img src="../../assets/images/img_85.png" alt="" v-if="ites.status == 2">
                        <img src="../../assets/images/img_84.png" alt="" v-else-if="ites.status == 3">
                    </div>

                </div>
                <div class="nothingTask" v-if="accomplish.length <= 0">
                    {{accomplishToast}}
                </div>
            </div>
        </div> -->

        <popup :pops='pops' @fatherMethod='fatherMethod' v-show="stateF"></popup>
    </div>
</template>

<script>
    // 引入弹窗
    import popup from '../../components/Popup.vue'

    export default {
        components:{
            popup
        },
        data() {
            return {
                headersText:'评论任务',
                switchColumn:['投放中','审核中','已完成'],
                switchNum:0,

                // 当前任务
                currentTasks:[],
                currentTaskToast:"正在加载当前任务中...",
                // 任务预告
                taskForecast:[],
                taskForecastToast:"正在加载任务预告中...",
                // 审核中
                examine:[],
                examineToast:'正在加载审核中任务...',
                // 已完成
                accomplish:[],
                accomplishToast:'正在加载已完成任务...',

                pops:{
                    icons:require('../../assets/images/img_61.png'), //可选
                    iconWidth:81, // 可选（若有图片必填）
                    iconHeight:81, // 可选（若有图片必填）
	                // iconMargin:'25px 0 8px',
                    tits1:'您未按照要求完成该任务', // 可选
                    // tits2:'快去分享给小伙伴吧', // 可选
                    // conts:'任务完成任务完成任务完成任务完成任务完成任务完成', // 可选
                    btns:'确定',
                    btnMarginTop:10
                },
                stateF:false
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            // 接口初始化（数据展示）
            init(){
                this.$loading(true);
                let datas = {}
                this.$http.GETS('comment_task/tasklist',datas,(res)=>{
                    this.$loading(false);
                    console.log(res.data);
                    this.currentTasks = res.data.nowtask
                    // this.taskForecast = res.data.aftertask
                    // this.examine = res.data.tuser_wait_audit_task
                    // this.accomplish = res.data.complete


                    this.currentTaskToast = '目前暂无任务，建议稍后刷新看看'
                    this.taskForecastToast = '目前暂无任务预告，建议稍后刷新看看'
                    this.examineToast = '目前暂无审核中任务'
                    this.accomplishToast = '目前没有已完成的任务'
                });
            },
            returnPage:function(){
                this.$router.go(-1);
            },
            switchChoose:function(indexs){
                this.switchNum = indexs
            },
            // 进入 高额任务进行页
            inHighTaskOngoing:function(item){
                this.$loading(true);

                //审核中的任务
                if(item.status == 1) {
                    this.$loading(false);
                    this.$toast('当前任务待审核，请抢其它任务！');
                    return;
                }
                // 进行中的任务
                if(item.status != 1 && item.current == 1) {
                    this.$router.push({name:'commentTaskOngoing',query: {ids:item.id}});
                    return;
                }

                // 未做的任务
                let datas = {
                    task_id:item.id
                }
                this.$http.POSTS('comment_task/startTask',datas,(res)=>{
                    this.$loading(false);
                    console.log(res.data);
                    this.$router.push({name:'commentTaskOngoing',query: {ids:item.id}});
                });
            },
            // 进入 提交审核细则
            inHighTaskExamineByLaws:function(){
                this.$router.push('/highTask/highTaskExamineByLaws');
            },
            // 进入 审核状态
            inAuditStatus:function(ids){
                this.$router.push({name:'auditStatus',query: {ids:ids}});
            },

            // 子组件方法
            fatherMethod:function(){
                this.stateF = false
                // this.$router.push('/');
            },

            // 是否完成任务
            lookState:function(state){
                if(state == 3){
                    this.stateF = true
                }
            }
        },

        beforeRouteEnter(to, from, next) {
            if(from.name=='auditStatus'){
                to.meta.keepAlive = true;
            } else {
                to.meta.keepAlive = false;
            }
            next();
        },
    }
</script>

<style lang="less" scoped>
    #highTask{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            .rule{
                font-size:15px;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 25px;
            }
        }
        // 导航切换栏
        .switchColumn{
            width:375px;
            height:44px;
            display: flex;
            .cols{
                width: 33.33%;
                font-size:16px;
                font-weight:600;
                line-height:16px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                .switchLine{
                    display: inline-block;
                    width:24px;
                    height:3px;
                    background:rgba(229,1,19,1);
                    border-radius:2px;
                    margin: 6px 0 5px;
                }
                .switchLineNone{
                    display: inline-block;
                    width:24px;
                    height:3px;
                    background:transparent;
                    border-radius:2px;
                    margin: 6px 0 5px;
                }
            }
        }
        // 投放中 审核中 已完成（公共）
        .currentTasks,.taskForecast,.examine,.accomplishTasks{
            width:345px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.5);
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 23px 0 30px;
                .linesR{
                    width:10px;
                    height:3px;
                    background:rgba(229,1,19,1);
                    border-radius:2px;
                }
                .fonts{
                    font-size:15px;
                    color:rgba(21,21,21,1);
                    line-height:15px;
                    font-weight: bold;
                    margin: 0 5px;
                }
            }
            .taskItem{
                margin: 0 15px 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .taskItemLeft{
                    display: flex;
                    align-items: center;
                    img{
                        width:60px;
                        height:60px;
                        border-radius: 12px;
                    }
                    .imgsDay{
                        width:60px;
                        height:60px;
                        border-radius:11px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        span{
                            font-size:13px;
                            color:rgba(255,255,255,1);
                            line-height:13px;
                            font-weight: bold;
                            &:first-of-type{
                                margin-bottom: 6px;
                            }
                            &:last-of-type{
                                font-family:'Qds';
                                font-size: 16px;
                            }
                        }
                    }
                    .imgsDayOne{
                        background:linear-gradient(319deg,rgba(255,38,96,1) 0%,rgba(255,181,47,1) 100%);
                    }
                    .imgsDayTwo{
                        background:linear-gradient(315deg,rgba(255,68,131,1) 0%,rgba(255,134,134,1) 100%);
                    }
                    .imgsDayThree{
                        background:linear-gradient(312deg,rgba(243,143,31,1) 0%,rgba(255,159,52,1) 100%);
                    }
                    .centers{
                        height: 60px;
                        margin-left: 15px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        .taskTile{
                            font-size:16px;
                            color:rgba(21,21,21,1);
                            line-height:16px;
                        }
                        .others{
                            span{
                                display: inline-block;
                                padding: 5px 13px;
                                border-radius:12px;
                                border:1px solid rgba(229,229,229,1);
                                font-size:12px;
                                color:rgba(153,153,153,1);
                                line-height:12px;
                                &:last-of-type{
                                    margin-left: 10px;
                                }
                            }
                            .pay{
                                background:rgba(255,227,227,1);
                                border:1px solid rgba(243,75,88,1);
                                color: #E50113;
                            }
                        }
                    }
                }
                .taskItemRight{
                    font-size:20px;
                    font-family: "Qds";
                    font-weight: bold;
                    color:rgba(230,9,26,1);
                    line-height:24px;
                    span{
                        font-size: 14px;
                        font-weight: normal;
                    }
                    img{
                        width: 55px;
                        height: 32px;
                    }
                }
                .taskItemRight{
                    // height: 100%;
                    font-size:20px;
                    font-weight: bold;
                    color:rgba(230,9,26,1);
                    line-height:24px;
                    white-space: nowrap;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .tuserNum{
                        font-family: "Qds";
                        span{
                            font-size: 14px;
                            font-weight: normal;
                        }
                    }
                    .onging{
                        color: #08A1F8;
                        font-size: 14px;
                        text-align: center;
                    }
                }
            }
            .nothingTask{
                margin: 25px 0;
                font-size:16px;
                color:rgba(153,153,153,1);
                line-height:11px;
                text-align: center;
            }
        }
        // 当前任务 任务预告
        .switchOne{
            .currentMargin{
                margin: 15px 15px 0;
            }
            .forecastMargin{
                margin: 10px 15px 0;
            }
            // 没有更多了
            .tips{
                padding: 15px 0;
                text-align: center;
                font-size:11px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:11px;
            }
        }
        // 审核中
        .switchTwo{
            .examineMargin{
                margin: 15px;
            }
            .firstPadding{
                padding-top: 30px;
            }
        }
        // 已完成
        .switchThree{
            .accomplishMargin{
                margin: 15px;
            }
            .firstPadding{
                padding-top: 30px;
            }
        }
        
    }
</style>